import { render } from "./holesChart.vue?vue&type=template&id=05780980"
import script from "./holesChart.vue?vue&type=script&lang=js"
export * from "./holesChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__